import cn from 'classnames';

import styles from './SocialLInks.module.css';

const SocialLInks = () => {
  return (
    <div className={styles.socialLinks}>
      <a 
        className={cn(styles.socialLink, styles.facebook)} 
        href="https://www.facebook.com/share/16oznWR8Rk/?mibextid=wwXIfr" 
        target="_blank"
        rel="noopener noreferrer"
      />
      <a 
        className={cn(styles.socialLink, styles.linkedin)} 
        href="https://www.linkedin.com/company/meal-well/" 
        target="_blank"
        rel="noopener noreferrer"
      />
      <a 
        className={cn(styles.socialLink, styles.tiktok)} 
        href="https://www.tiktok.com/@mealwell.ai?_t=ZN-8x3y8IFQwop&_r=1" 
        target="_blank"
        rel="noopener noreferrer"
      />
      <a 
        className={cn(styles.socialLink, styles.instagram)} 
        href="https://www.instagram.com/mealwell.app?igsh=bzI0YmRwNWw5M2p1&utm_source=qr" 
        target="_blank"
        rel="noopener noreferrer"
      />
      <a 
        className={cn(styles.socialLink, styles.youtube)} 
        href="https://youtube.com/@mealwellai?si=krTc8m4ncCQTj5YN" 
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  );
};

export default SocialLInks;